import React, { useState } from 'react'
import { Tabs } from 'antd'
import { TabStyle } from './style'
import SummaryTable from './SummaryTable'
import PaydaySummaryTable from './PaydaySummaryTable'
import PaydayDetailTable from './PaydayDetailTable'
import OtherSummaryTable from './OtherSummaryTable'
import OtherDetailTable from './OtherDetailTable'
import OtherWithdrawDetailTable from './OtherWithdrawDetailTable'
import useAxios from 'axios-hooks'

const InvoiceSummaryTab = ({ invoice_group_id, resign }) => {
  const [pageSize, setPageSize] = useState(20)
  const [currentPage, setCurrentPage] = useState(1)
  const [search, setSearch] = useState('')
  const [sort, setSort] = useState('')

  const [{ data, loading, error }, refetch] = useAxios(
    {
      url: `/admins/api/invoice_groups/${invoice_group_id}/summaries?per_page=${pageSize}&page=${currentPage}&search=${search}&resign=${resign}&sort=${sort ?? ''}`,
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      },
    },
    {
      useCache: false,
    }
  )

  const onChange = async (key) => {
    if (key === '1') {
      await refetch()
    }
  }

  const items = [
    {
      key: '1',
      label: 'สรุปรายการหักเงินเดือน',
      children: <SummaryTable invoice_group_id={invoice_group_id}
        data={data}
        loading={loading}
        pageSize={pageSize}
        setPageSize={setPageSize}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearch={setSearch}
        setSort={setSort}
      />,
    },
    {
      key: '4',
      label: 'ยอดหักสินเชื่อ',
      children: <OtherSummaryTable invoice_group_id={invoice_group_id} resign={resign} />,
    },
    {
      key: '5',
      label: 'รายละเอียดสินเชื่อ',
      children: <OtherDetailTable invoice_group_id={invoice_group_id} resign={resign} />
    },
    {
      key: '2',
      label: 'ยอดหัก PAYDAY',
      children: <PaydaySummaryTable invoice_group_id={invoice_group_id} resign={resign} />,
    },
    {
      key: '3',
      label: 'รายละเอียด PAYDAY',
      children: <PaydayDetailTable invoice_group_id={invoice_group_id} resign={resign} />,
    },
    {
      key: '6',
      label: 'รายละเอียดเบิกถอนสินเชื่อ',
      children: <OtherWithdrawDetailTable invoice_group_id={invoice_group_id} resign={resign} />,
    },
  ]

  return (<TabStyle>
    <Tabs type="card" size="large" defaultActiveKey="1" items={items} onChange={onChange} />
  </TabStyle>)
}

export default InvoiceSummaryTab
